module.exports = __webpack_public_path__ + "images/emoji/alien.c3f553b2608bf5cf39b5.png";